import { useStore } from "csi/state/hooks";
import Button from "designSystem/components/button/Button";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import { MultiSelect } from "designSystem/index";
import { white } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React from "react";

export const SaveSnapshotPlaceholder = observer(() => {
	const { threeDStore } = useStore();
	const { 
		uploadNewSnapshots, 
		selectedSnapshots, 
		saveLocations, 
		canSaveImages, 
		setSelectedSnapshotSaveLocations, 
		selectedSnapshotSaveLocations,
		suggestedSaveLocations,
	 } = threeDStore.snapshotsStore;
	const isEnabled = !!selectedSnapshots.length;

	return (
		<FlexRowCenter
			bgcolor={white[50]}
			borderTop={STANDARD_BORDER_STYLE}
			bottom={0}
			gap={2}
			justifyContent="space-between"
			p={3}
			position="sticky"
		>
			 { isEnabled && (
				<MultiSelect
					grouped
					noChips
					onChange={setSelectedSnapshotSaveLocations}
					options={saveLocations}
					placeHolderRes="Select"
					suggestedGroups={suggestedSaveLocations}
					sx={{
						width: "50%",
					}}
					value={selectedSnapshotSaveLocations}
				/>
			)
			}
			<Button
				design="primary"
				disabled={!canSaveImages}
				onClick={uploadNewSnapshots}
				res={isEnabled ? "SaveWithCount" : "Save"}
				resParams={[selectedSnapshots.length]}
				sx={{
					width: isEnabled ? "50%" : "100%",
				}}
			/>
		</FlexRowCenter>
	);
});